<template>
	<div class="row" v-if="hasCompanion">
		<div class="col">
			<div class="mt-3">
				<div class="mb-1">
					<span class="h4">Companion</span>
					<span class="float-right lead">{{companion.Name}}</span>
				</div>
				<p class="float-right mb-1"><i>{{companion.Type}} {{companion.Level}}</i></p>
			</div>
			<div class="table-responsive">
				<table class="table table-sm table-bordered table-striped mb-0">
					<tbody>
						<tr>
							<td><strong>HP</strong> <small class="text-muted">Health</small></td>
							<td style="width: 4em;"></td>
							<td style="text-align:right;">{{stats.HP}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<ul class="list-group list-group-flush">
				<li class="list-group-item p-0 bt-0">
					<span class="lead">Defense</span>
					<ul class="list-inline">
						<li class="list-inline-item"><strong>EAC</strong> {{stats.EAC}}</li>
						<li class="list-inline-item"><strong>KAC</strong> {{stats.KAC}}</li>
						<li class="list-inline-item"><strong>Fort</strong> {{ (companion.GoodSave == "Fortitude" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
						<li class="list-inline-item"><strong>Ref</strong> {{ (companion.GoodSave == "Reflex" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
						<li class="list-inline-item"><strong>Will</strong> {{ (companion.GoodSave == "Will" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
					</ul>
				</li>
				<li class="list-group-item p-0">
					<span class="lead">Offense</span>
					<div>
						<strong>Speed</strong> {{companion.Speed}}
					</div>
					<ul class="list-inline" v-if="attacks.melee.length > 0">
						<li class="list-inline-item"><strong>Melee</strong></li>
						<li class="list-inline-item" v-for="(attack, index) in attacks.melee" :key="'attacksMelee-'+index">
							{{attack.Name}} {{stats.BAB|bonus}} ({{stats.DamageDie}}+{{stats.DamageMod+companionMod(companion, "Strength")}} {{attack.Damage}})
						</li>
					</ul>
					<ul class="list-inline" v-if="attacks.ranged.length > 0">
						<li class="list-inline-item"><strong>Ranged</strong></li>
						<li class="list-inline-item" v-for="(attack, index) in attacks.ranged" :key="'attacksRanged-'+index">
							{{attack.Name}} {{stats.BAB|bonus}} ({{stats.DamageDie}}+{{stats.DamageMod}} {{attack.Damage}})
						</li>
					</ul>
				</li>
				<li class="list-group-item p-0">
					<span class="lead">Statistics</span>
					<div>
						<span v-for="(mod,ability) in companion.AbilityMods" :key="ability">
							<strong>{{ability|abbr}}</strong> {{companionMod(companion, ability)|bonus}}; 
						</span>
					</div>
				</li>
				<li class="list-group-item p-0">
					<span class="lead">Special Abilities</span>
					<ul class="list-inline">
						<li class="list-inline-item" v-for="(special, index) in companion.Specials" :key="'companionAbility-'+index">
							<b>{{special.Name}} ({{special.Type}})</b>
							<p>{{special.Description}}</p>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	methods: {
		abilityMod: function(score) {
			return Math.floor((score - 10) / 2)
		},
		companionMod: function(companion, ability){
			var mod = companion.AbilityMods[ability];
			if(ability == companion.AbilityBest){
				mod += this.stats.AbilityModGood
			}else if(ability == companion.AbilityBetter){
				mod += this.stats.AbilityModPoor
			}
			return mod;
		},
		percentage: function(fraction, whole){
			return Math.round( (fraction/whole)*100 )+'%';
		},
	},
	computed: {
		level: function() {
			return this.$store.getters['currentLevel']
		},
		companion: function() {
			return this.$store.state.Character.Levels[ this.level ].Companion
		},
		current: function() {
			return this.$store.state.Character.Current.Companion
		},
		stats: function() {
			return this.$store.getters['character/companions/stats']
		},
		attacks: function(){
			if(this.stats !== null){
				var melee = [];
				var ranged = [];
				var attacks = this.companion.Attacks || null;
	
				if(attacks !== null){
					attacks.forEach(attack => {
						if(attack.Type == "Melee")
							melee.push(attack);
						else if(attack.Type == "Ranged")
							ranged.push(attack);
					});
				}
	
				return {
					"melee": melee,
					"ranged": ranged
				};
			}else{
				return null;
			}
			
		},
		HP: {
			get: function() {
				return this.current.Points.Hit
			},
			set: function(value) {
				return this.$store.dispatch('character/companions/setHP',value)
			}
		},
		...mapGetters('character/companions',[
			'hasCompanion',
		]),
	},
}
</script>

<style scoped>

</style>